<script lang="ts">
import Check from "~icons/ph/check-bold"
let {
  class: className = ""
} = $props()
</script>
<span class={`w-8 h-8 inline-flex items-center justify-center bg-success rounded-full ${className}`}>
  <Check class="w-5 h-5 text-white"/>
</span>
